module.exports = __webpack_public_path__ + "img/thumbnail_SussexChicken_j_leucistic.0e225597.png";